/**
 * client/src/lib/use-media.ts
 *
 * Media-query hooks for adaptive rendering.
 *
 * useIsMobile() — returns true when the viewport is below the 768px breakpoint
 * (i.e. matches `(max-width: 767px)`).  Subscribes to MediaQueryList change
 * events so it re-renders automatically when the viewport crosses the threshold.
 */

import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
